import { Instagram, Linkedin } from "lucide-react";
import { Link } from "react-router-dom";
import { scrollToSection } from "@/lib/scroll";
import { CONTACTS } from "./data";

const LINKS = [
  { label: "Chi Siamo", target: "#chi-siamo", testid: "footer-chi-siamo-link" },
  { label: "Soluzioni", target: "#lavori", testid: "footer-soluzioni-link" },
  { label: "Servizi", target: "#servizi", testid: "footer-servizi-link" },
  { label: "Contatti", target: "#contatti", testid: "footer-contatti-link" },
];

const SOCIALS = [
  { icon: Instagram, label: "Instagram", url: "https://instagram.com/furlanprintcopy", testid: "social-instagram-link" },
  { icon: Linkedin, label: "LinkedIn", url: "https://www.linkedin.com/in/alessandro-furlan-656a2013a", testid: "social-linkedin-link" },
];

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-[#181817] text-[#FBF9F5] pt-20 pb-10 px-6 sm:px-12 lg:px-20">
    <div className="max-w-7xl mx-auto">
      <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-12 border-b border-[#FBF9F5]/10 pb-16">
        <div>
          <img
            data-testid="footer-brand"
            src="/logo.png"
            alt="Furlan Print & Copy — Noleggio e Assistenza Stampanti"
            className="w-64 sm:w-80 rounded-sm"
          />
        </div>
        <div className="flex flex-col gap-8">
          <nav className="flex flex-wrap gap-x-8 gap-y-3">
            {LINKS.map((l) => (
              <button
                key={l.target}
                data-testid={l.testid}
                onClick={() => scrollToSection(l.target)}
                className="text-sm text-[#FBF9F5]/60 hover:text-[#FBF9F5] transition-colors duration-300"
              >
                {l.label}
              </button>
            ))}
          </nav>
          <div className="flex gap-4">
            {SOCIALS.map(({ icon: Icon, label, url, testid }) => (
              <a
                key={label}
                data-testid={testid}
                href={url}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={label}
                className="w-11 h-11 rounded-full border border-[#FBF9F5]/20 flex items-center justify-center text-[#FBF9F5]/70 hover:bg-[#C85A32] hover:border-[#C85A32] hover:text-[#FBF9F5] transition-colors duration-300"
              >
                <Icon size={16} />
              </a>
            ))}
          </div>
        </div>
      </div>
      <div className="pt-8 flex flex-col sm:flex-row justify-between gap-3">
        <p className="font-mono text-[10px] tracking-[0.15em] uppercase text-[#FBF9F5]/40">
          © 2026 Furlan Print Copy — Viale dell'Industria 3, Paderno Dugnano (MI) — P.IVA {CONTACTS.piva}
        </p>
        <div className="flex items-center gap-6">
          <Link
            data-testid="footer-privacy-link"
            to="/privacy"
            className="font-mono text-[10px] tracking-[0.15em] uppercase text-[#FBF9F5]/40 hover:text-[#FBF9F5] transition-colors duration-300"
          >
            Privacy & Cookie Policy
          </Link>
          <a
            data-testid="footer-website-link"
            href={CONTACTS.websiteUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="font-mono text-[10px] tracking-[0.15em] uppercase text-[#FBF9F5]/40 hover:text-[#FBF9F5] transition-colors duration-300"
          >
            {CONTACTS.website}
          </a>
        </div>
      </div>
    </div>
  </footer>
);
